module.exports = __webpack_public_path__ + "static/img/3.70a7685.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/imgs/goods/xiaoshuo/3.png
// module id = m1Ae
// module chunks = 1